module.exports = __webpack_public_path__ + "img/hotmart-white.f4a42bb9.svg";